import { InfoBlock as InfoBlockUI } from "@repo/ui-parkmobile/InfoBlock";
import type { InfoBlock } from "@/generated/sb";
import { titleResolver } from "@/lib/storyblok/adaptors";
import { storyblokEditable } from "@storyblok/react/rsc";
import { SimpleRichText } from "@/components/SimpleRichText";

interface InfoBlockProps {
  blok: InfoBlock;
  pageType?: "default" | "location";
}

export default function InfoBlock({
  blok,
  pageType = "default",
}: InfoBlockProps) {
  if (!blok) {
    return null;
  }

  const title = blok.title?.[0] ? titleResolver(blok.title) : null;
  const text = blok.text?.[0] ? <SimpleRichText blok={blok.text[0]} /> : null;

  return (
    <InfoBlockUI
      {...storyblokEditable(blok)}
      title={title}
      text={text}
      backgroundColor={blok.backgroundColor || "none"}
      topPadding={blok.topPadding || "default"}
      bottomPadding={blok.bottomPadding || "default"}
      pageType={pageType}
    />
  );
}
